import { render, staticRenderFns } from "./Oauth.vue?vue&type=template&id=b8987202"
import script from "./Oauth.vue?vue&type=script&lang=js"
export * from "./Oauth.vue?vue&type=script&lang=js"
import style0 from "./Oauth.vue?vue&type=style&index=0&id=b8987202&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports